<template>
  <el-card shadow="never">
    <el-tabs v-model="activeMapName">
      <el-tab-pane :label="$t('operate.name74')" name="first">
        <template>
            <div id="mapDiv" class="bm-view"></div>
             <el-input type="text" id="keyWord" v-model="keyword" onpropertychange="localsearch.search(document.getElementById('keyWord').value,4)" :placeholder="$t('public.name5')" class="serachinput">
               <el-button slot="append" icon="el-icon-search" @click="searchKeyword"></el-button>
             </el-input>
             <!-- <el-input v-model="addressKeyword" id="keyWord"  onpropertychange="localsearch.search(document.getElementById('keyWord').value,4)" :placeholder="$t('public.name5')" class="serachinput"></el-input> -->
             <div class="suggests" v-if="addressList.length > 0">
              <div v-for="(item,index) in addressList" :key="index">
                <div style="cursor: pointer;" @click="selectAddress(item)">{{ item.address }}{{ item.name }}</div>
              </div>
             </div>
          <!-- <baidu-map class="bm-view" :center="baiduMapCenter" :zoom="16" :scroll-wheel-zoom="true" @ready="handleMap">
            <bm-marker :position="{ lng: item.lng, lat: item.lat }" v-for="(item, index) in polygonPath" :key="index" :icon="iconpoint" :offset="{ width: 20, height: -10 }">
              <bm-label :content="item.name" :labelStyle="{ color: 'red', fontSize: '12px' }" :offset="{ width: 30, height: 10 }" />
            </bm-marker>
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
            <bm-auto-complete v-model="addressKeyword" :sugStyle="{ zIndex: 999999 }">
              <el-input v-model="addressKeyword" :placeholder="$t('public.name5')" class="serachinput"></el-input>
            </bm-auto-complete>
            <bm-local-search
              :keyword="addressKeyword"
              :pageCapacity="1"
              :panel="isShowPanel"
              :auto-viewport="true"
              :selectFirstResult="true"
              @searchcomplete="searchcomplete"
              style="width: 0px; height: 0px; overflow: hidden"
            ></bm-local-search>
          </baidu-map> -->
        </template>
      </el-tab-pane>
      <el-tab-pane :label="$t('operate.name73')" name="second">
        <template>
          <div class="gm-view">
            <el-autocomplete
            class="place-autocomplete-card"
            v-model="addressKeyword1"
            :fetch-suggestions="querySearchAsync"
            :placeholder="$t('public.name5')"
            @select="handleSelect">
          </el-autocomplete>
            <div :style="googleMapStyle" class="googleMap" :id="mapID"></div>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import coordtransform from 'coordtransform'
import { Loader } from '@googlemaps/js-api-loader' // 引入
export default {
  props: {
    // obj: {
    //   type: Object,
    //   required: false
    // },
    fenceId: {
      type: String,
      default: ''
    }
  },
  watch: {
    // keyword (newVal) {
    //   console.log('newVal====', newVal)
    //   if (this.localsearch && newVal) {
    //     this.localsearch.search(newVal, 4)
    //   } else if (!newVal) {
    //     this.clearAll()
    //   }
    // }
  },
  components: {
  },
  data () {
    return {
      localsearch: null,
      keyword: '',
      map: null,
      BMap: null,
      longitude: '',
      latitude: '',
      address: '',
      isShowPanel: true,
      infoWindowShow: false,
      addressKeyword: '',
      // 地图切换
      activeMapName: 'first',
      baiduMapCenter: { lng: '119.068917', lat: '31.672315' },
      // 详情、修改围栏
      polygonPath: [],
      editRegionFrom: {
        fenceName: '',
        fenceType: '',
        regionId: '',
        fencePointList: []
      },
      fenceIdinfo: '',
      iconpoint: {
        url: require('@/assets/point.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      iconpointgoogle: {
        url: require('@/assets/point.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      polygonPathgooglepolygonPath: [],
      Polygonloading: true,
      pointnew: false,
      polygonPathpush: [],
      // 谷歌地图样式
      polygonPathgoogle: [],
      polygonPathgooglepush: [],
      mapID: 'googleMap',
      mapType: 'POLYGON',
      googleMapStyle: {
        wdith: '100%',
        height: '500px'
      },
      mapOptions: {
        // 为了关闭默认控件集,设置地图的disableDefaultUI的属性为true
        disableDefaultUI: false,
        // 启用缩放和平移
        gestureHandling: 'greedy',
        panControl: true,
        zoomControl: true,
        scaleControl: true,
        // 关闭街景
        streetViewControl: false
      },
      // 谷歌地图缩放级别
      zoom: 16,
      // 谷歌地图中心点
      googleMapCenter: {
        lng: 119.068917,
        lat: 31.672315
      },
      // 谷歌地图图形path
      mapPath: [],
      markers: [],
      // 地图选点回显值
      longlat: '',
      // 标记点
      marker: [],
      // 图标实例
      markerBlack: [],
      // 图形实例
      graphicalExample: null,
      // 图形路径经纬度
      graphicalPath: [],
      apiKey: 'AIzaSyBQZEsRZwha4KWyKHD-TfZ9wOnzmwxXmz4',
      as: [],
      infoWindow: {
        info: {}
      },
      searchBox: null,
      service: null,
      addressKeyword1: '',
      list: [],
      geocoder: null,
      mapTD: null,
      T: null,
      addressList: [],
      geocode: null,
      lng: 0,
      lat: 0
    }
  },
  created () {
    this.$nextTick(() => {
      const loader = new Loader({
        apiKey: this.apiKey, // 之前的key
        version: 'weekly', // 版本
        libraries: ['places', 'drawing'], // 插件库places为基础库 drawing为绘制工具库
        region: 'Canada',
        language: 'en'
      })
      const mapOptions = {
        center: {
          lat: this.googleMapCenter.lat * 1,
          lng: this.googleMapCenter.lng * 1
        }, // 中心点
        zoom: this.zoom, // 缩放级别
        ...this.mapOptions // 其他配置
      }
      loader
        .load()
        .then((google) => {
          const map = new google.maps.Map(document.getElementById(this.mapID), mapOptions)
          this.googleMap = map
          this.googleApi = google
          this.searchBox = new google.maps.places.AutocompleteService()
          this.service = new google.maps.places.PlacesService(map)
          this.geocoder = new google.maps.Geocoder()
          this.marker = new google.maps.Marker({
            map: map,
            position: {},
            draggable: true
          })
        })
        .catch((e) => {
          // do something
          console.log(e)
        })
    })
  },
  computed: {},
  mounted() {
    this.T = window.T
    this.mapTD = new this.T.Map('mapDiv', {
      attributionControl: true,
      inertia: true
    })
    const control = new this.T.Control.Zoom()
    this.mapTD.addControl(control)
    this.mapTD.centerAndZoom(new this.T.LngLat(this.baiduMapCenter.lng, this.baiduMapCenter.lat), 18)
    var config = {
      pageCapacity: 10,
      onSearchComplete: this.localSearchResult
    }
    this.localsearch = new this.T.LocalSearch(this.mapTD, config)
    const that = this
    this.mapTD.addEventListener('click', function (e) {
      console.log('e===', e)
      that.geocode = new that.T.Geocoder()
      that.geocode.getLocation(e.lnglat, that.searchResult)
    })
  },
  methods: {
    searchKeyword() {
      if (this.localsearch && this.keyword) {
        this.localsearch.search(this.keyword, 4)
      }
    },
    localSearchResult (result) {
      this.clearAll()
      this.suggests(result.getSuggests())
    },
    suggests (obj) {
      if (obj) {
        // console.log('obj===', obj)
        this.addressList = obj
      }
    },
    selectAddress (item) {
      const that = this
      this.lng = item.lonlat.split(',')[0]
      this.lat = item.lonlat.split(',')[1]
      that.mapTD.centerAndZoom(new that.T.LngLat(this.lng, this.lat), 18)
      that.geocode = new that.T.Geocoder()
      that.geocode.getLocation(new that.T.LngLat(this.lng, this.lat), that.searchResult)
    },
    searchResult (result) {
      if (result.getStatus() === 0) {
        var getAddressComponent = result.getAddressComponent()
        var addressComponent = getAddressComponent.addressComponent
        console.log('addressComponent===', result)
        // console.log('addressComponent===', addressComponent)
        const addressInfo = {
          address: addressComponent.address,
          lng: this.lng,
          lat: this.lat,
          province: addressComponent.province,
          city: addressComponent.city,
          region: addressComponent.county
        }
        this.$bus.$emit('addressInfo', addressInfo)
        this.addressList = []
        this.keyword = ''
      }
    },
    clearAll () {
      this.mapTD.clearOverLays()
      // document.getElementById('suggestsDiv').innerHTML = ''
      // document.getElementById('suggestsDiv').style.display = 'none'
    },
    // getMapLocation(results, status) {
    //   if (status === 'OK') {
    //     this.googleMap.setCenter(results[0].geometry.location)
    //     this.marker.setPosition(results[0].geometry.location)
    //   } else {
    //     console.log('error')
    //   }
    // },
    handleSelect(item) {
      this.service.getDetails({ placeId: item.place_id }, (event, status) => {
        if (status === 'OK') {
          console.log('event===', event)
          this.addressKeyword1 = event.name
          this.marker.setPosition(event.geometry.location)
          this.googleMap.setCenter(event.geometry.location)
          const addressInfo = {
            address: event.formatted_address,
            lng: Number(event.geometry.location.lng()),
            lat: Number(event.geometry.location.lat()),
            province: '',
            city: '',
            region: ''
          }
          this.$bus.$emit('addressInfo', addressInfo)
          // 对请求进行地理编码
          // this.geocoder.geocode({ address: this.addressKeyword1 }, this.getMapLocation())
        } else {
        }
      })
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === '') {
        this.list = []
        return cb(this.list)
      }
      this.searchBox.getPlacePredictions({ input: queryString }, (event, status) => {
        if (status === 'OK') {
          this.list = event || []
          // place_id 后面有用，所以只保留存在place_id的数据
          this.list = this.list.filter((x) => x.place_id)
        } else {
          this.list = []
        }
        this.list.map((item) => {
          item.value = item.description
        })
        console.log('===', this.list)
        cb(this.list)
      })
    },
    searchcomplete(results) {
      this.isShowPanel = true
      if (results) {
        console.log('this.as====', results)
        this.as = results.Rr
        // console.log('this.as====', this.as)
        const geoc = new this.BMap.Geocoder()
        geoc.getLocation(this.as[0].point, (rs) => {
          console.log('rs=====', rs)
          if (rs.surroundingPois.length) {
            this.address = rs.surroundingPois[0].address
            this.latitude = rs.surroundingPois[0].point.lat
            this.longitude = rs.surroundingPois[0].point.lng
            const bikepointbaidu = coordtransform.bd09togcj02(this.longitude, this.latitude)
            const bikepointsbaidu = coordtransform.gcj02towgs84(bikepointbaidu[0], bikepointbaidu[1])
            const addressInfo = {
              address: rs.surroundingPois[0].address,
              lng: Number(bikepointsbaidu[0]),
              lat: Number(bikepointsbaidu[1]),
              province: rs.addressComponents.province,
              city: rs.addressComponents.city,
              region: rs.addressComponents.district
            }
            this.$bus.$emit('addressInfo', addressInfo)
          } else {
            this.address = rs.address
            this.latitude = rs.point.lat
            this.longitude = rs.point.lng
            const bikepointbaidu = coordtransform.bd09togcj02(this.longitude, this.latitude)
            const bikepointsbaidu = coordtransform.gcj02towgs84(bikepointbaidu[0], bikepointbaidu[1])
            const addressInfo = {
              address: rs.address,
              lng: Number(bikepointsbaidu[0]),
              lat: Number(bikepointsbaidu[1]),
              province: rs.addressComponents.province,
              city: rs.addressComponents.city,
              region: rs.addressComponents.district
            }
            this.$bus.$emit('addressInfo', addressInfo)
          }
        })
      }
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
    },
    // async getfirstPath() {
    //   this.Polygonloading = true
    //   this.pointnew = false
    //   const res = await findFenceDetail({ fenceId: this.fenceId })
    //   this.editRegionFrom = res.data.fence
    //   if (this.activeMapName === 'first') {
    //     // this.Polygonloading = false
    //     this.baidumapsetmaps()
    //   } else if (this.activeMapName === 'second') {
    //     this.googlemapstemasps()
    //   }
    // },
    // 百度处理坐标
    baidumapsetmaps () {
      this.polygonPath = this.editRegionFrom.fencePointList
      if (this.polygonPath.length) {
        this.baiduMapCenter = { lng: this.polygonPath[0].lng, lat: this.polygonPath[0].lat }
      }
      this.polygonPath.forEach((list, index) => {
        const bikepointbaidu = coordtransform.wgs84togcj02(list.lng, list.lat)
        const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
        list.lng = Number(bikepointsbaidu[0])
        list.lat = Number(bikepointsbaidu[1])
      })
      setTimeout(() => {
        this.getPolygonPath()
        this.Polygonloading = false
      }, 1000)
    },
    // 谷歌处理坐标
    googlemapstemasps () {
      this.polygonPathgoogle = this.editRegionFrom.fencePointList
      this.polygonPathgoogle.forEach((list, index) => {
        const bikepoint = coordtransform.wgs84togcj02(list.lng, list.lat)
        list.lng = Number(bikepoint[0])
        list.lat = Number(bikepoint[1])
      })
      this.mapPath = this.polygonPathgoogle
      setTimeout(() => {
        this.echoGraphical()
        this.Polygonloading = false
      }, 1000)
    },
    getgooglePolygonPath () {
      const poiylist = []
      this.mapPath.forEach((list, index) => {
        poiylist.push({
          name: this.$t('screen.name169') + (index + 1),
          serialNo: index + 1,
          edit: false,
          index: index + 1,
          lng: list.lng,
          lat: list.lat
        })
      })
      this.mapPath = poiylist
    },
    getPolygonPath () {
      const poiylist = []
      this.polygonPath.forEach((list, index) => {
        poiylist.push({
          name: this.$t('screen.name169') + (index + 1),
          serialNo: index + 1,
          edit: false,
          index: index + 1,
          lng: list.lng,
          lat: list.lat
        })
      })
      this.polygonPath = poiylist
    },
    updatePolygonPath (e) {
      this.polygonPath = e.target.getPath()
      const poiylist = []
      this.polygonPath.forEach((list, index) => {
        poiylist.push({
          name: this.$t('screen.name169') + (index + 1),
          edit: false,
          serialNo: index + 1,
          index: index + 1,
          lng: list.lng,
          lat: list.lat
        })
      })
      this.polygonPath = poiylist
    },
    editPolygonPath (item) {
      if (this.pointnew === false) {
        this.pointnew = true
        item.edit = true
      } else {
        this.$message.error(this.$t('screen.name173'))
      }
    },
    locationPoints(item) {
      console.log('item====', item)
      if (this.activeMapName === 'first') {
        this.baiduMapCenter = { lng: item.lng, lat: item.lat }
      }
    },
    savePolygonPath (item) {
      item.edit = false
      this.pointnew = false
      this.getPolygonPath()
    },
    deletePolygonPath (index) {
      this.polygonPath.splice(index.$index, 1)
    },
    deletePolygonPathgoogle (index) {
      this.mapPath.splice(index.$index, 1)
      // this.mapPath = this.polygonPathgoogle
      this.echoGraphical()
    },
    firstdeletePolygonPath (index) {
      this.pointnew = false
      this.polygonPath.splice(index.$index, 1)
    },
    mouseoutpath () {
    },
    mouseoverpath () {
    },
    addPolygonPath () {
      if (this.pointnew === false) {
        this.pointnew = true
        this.polygonPath.push({
          name: this.$t('screen.name174'),
          edit: true,
          lng: '',
          lat: ''
        })
      } else {
        this.$message.error(this.$t('screen.name175'))
      }
    },
    // 谷歌
    async uploadPolygonPathgoogle () {
      // this.mapPath.forEach((list, index) => {
      //   const bikepoints = coordtransform.gcj02towgs84(list.lng, list.lat)
      //   list.lng = Number(bikepoints[0])
      //   list.lat = Number(bikepoints[1])
      // })
      // this.polygonPathgooglepush = this.mapPath
      // this.getPolygonPath()
      // // console.log(this.polygonPath)
      // await modifyFence({
      //   fenceId: this.fenceId,
      //   fenceType: this.editRegionFrom.fenceType,
      //   fencePointList: this.polygonPathgooglepush
      // }).then((res) => {
      //   if (res.code === 200) {
      //     this.$message.success(this.$t('operate.name85'))
      //   }
      // }).catch(() => {})
    },
    // 百度
    async uploadPolygonPath () {
      // this.polygonPathpush = JSON.parse(JSON.stringify(this.polygonPath))
      // this.polygonPathpush.forEach((list, index) => {
      //   const bikepointbaidu = coordtransform.bd09togcj02(list.lng, list.lat)
      //   const bikepointsbaidu = coordtransform.gcj02towgs84(bikepointbaidu[0], bikepointbaidu[1])
      //   list.lng = Number(bikepointsbaidu[0])
      //   list.lat = Number(bikepointsbaidu[1])
      // })
      // console.log('this.polygonPathpush====', this.polygonPathpush)
      // this.polygonPath.forEach((list, index) => {
      //   const bikepointbaidu = coordtransform.wgs84togcj02(list.lng, list.lat)
      //   const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
      //   list.lng = Number(bikepointsbaidu[0])
      //   list.lat = Number(bikepointsbaidu[1])
      // })
      // this.getPolygonPath()
      // const polygonPathpush = []
      // this.polygonPathpush.map((item, index) => {
      //   polygonPathpush.push({
      //     lat: item.lat,
      //     lng: item.lng,
      //     edit: item.edit,
      //     name: item.name,
      //     serialNo: index + 1,
      //     index: index + 1
      //   })
      // })
      // await modifyFence({
      //   fenceId: this.fenceId,
      //   fenceType: this.editRegionFrom.fenceType,
      //   fencePointList: polygonPathpush
      // }).then((res) => {
      //   if (res.code === 200) {
      //     this.$message.success(this.$t('operate.name85'))
      //   }
      // }).catch(() => {})
    },
    // 谷歌地图
    echoGraphical () {
      if (this.mapType === 'POLYGON') {
        // 回显多边形
        this.getgooglePolygonPath()
        this.graphicalPath = this.mapPath
        // const paths = JSON.parse(this.graphicalPath)
        const paths = this.graphicalPath
        // 存在就清除上一个图形
        if (this.graphicalExample) {
          this.graphicalExample.setMap(null)
        }
        if (this.markerBlack) {
          for (var i = 0; i < this.markerBlack.length; i++) {
            this.markerBlack[i].setMap(null)
          }
          this.markerBlack = []
        }
        // Construct a draggable red triangle with geodesic set to true.
        this.graphicalExample = new this.googleApi.maps.Polygon({
          paths,
          fillColor: 'blue',
          strokeColor: 'blue',
          strokeOpacity: 0.8,
          fillOpacity: 0.4,
          strokeWeight: 5,
          clickable: true,
          editable: true,
          zIndex: 1
        })
        if (this.mapPath.length > 0) {
          this.graphicalExample.setMap(this.googleMap)
          this.mapPath.forEach((list, index) => {
            const marker = new this.googleApi.maps.Marker({
              position: {
                lat: list.lat,
                lng: list.lng
              },
              icon: this.iconpointgoogle,
              title: this.$t('screen.name169') + (index + 1)
            })
            this.markerBlack.push(marker)
          })
          // 监听回显图形每一个路径点
          this.googleApi.maps.event.addListener(this.graphicalExample.getPath(), 'insert_at', (event) => {
            this.setPath(this.graphicalExample.getPath().Eg)
          })
          this.googleApi.maps.event.addListener(this.graphicalExample.getPath(), 'set_at', (event) => {
            this.setPath(this.graphicalExample.getPath().Eg)
          })
        }
        for (let i = 0; i < this.markerBlack.length; i++) {
          this.markerBlack[i].setMap(this.googleMap)
        }
      }
    },
    // path路径emit传出
    setPath (path) {
      this.graphicalPath = []
      if (path.length > 0) {
        path.forEach((v, index) => {
          this.graphicalPath.push({
            name: this.$t('screen.name169') + (index + 1),
            serialNo: index + 1,
            edit: false,
            index: index + 1,
            lat: v.lat(),
            lng: v.lng()
          })
        })
        this.mapPath = this.graphicalPath
        // this.polygonPathgoogle = this.graphicalPath
        // this.echoGraphical()
        // console.log(this.polygonPath)
        this.$emit('getGraphicalPath', this.mapPath)
        if (this.markerBlack) {
          for (var i = 0; i < this.markerBlack.length; i++) {
            this.markerBlack[i].setMap(null)
          }
          this.markerBlack = []
        }
        if (this.mapPath) {
          this.mapPath.forEach((list, index) => {
            const marker = new this.googleApi.maps.Marker({
              position: {
                lat: list.lat,
                lng: list.lng
              },
              icon: this.iconpointgoogle,
              title: this.$t('screen.name169') + (index + 1)
            })
            this.markerBlack.push(marker)
          })
        }
        for (let i = 0; i < this.markerBlack.length; i++) {
          this.markerBlack[i].setMap(this.googleMap)
        }
      }
    },
    // 移动标记点回调
    updateMaker (e) {
      this.longlat = e.latLng.lat() + ',' + e.latLng.lng()
      this.$emit('setLongLat', this.longlat)
    },
    // 添加可拖动的标记点
    addDraggableMarkers (max, draggable, {
      lat = 0,
      lng = 0
    }) {
      if (max !== -1) {
        this.marker.forEach((marker) => {
          marker.setMap(null)
        })
        this.marker = []
      }
      this.marker.push(
        new this.googleApi.maps.Marker({
          map: this.googleMap,
          position: {
            lat: lat,
            lng: lng
          },
          draggable: draggable
        })
      )
      if (draggable) {
        this.marker[0].addListener('dragend', (e) => {
          this.updateMaker(e)
        })
      }
    }
  }
}
</script>
<style lang="scss">
.el-autocomplete-suggestion li {
  white-space: normal !important;
}
</style>
<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 500px;
  position: relative;
}
.gm-view{
  width: 100%;
  height: 500px;
  position: relative;
}
.serachinput {
  position: absolute;
  top: 10px;
  left: 50px;
  width: 30%;
  z-index: 9999;
}
.suggests{
  position: absolute;
  top: 50px;
  left: 50px;
  width: 30%;
  max-height: 300px;
  overflow: auto;
  z-index: 9999;
  font-size: 13px;
  border: 1px solid #C0C4CC;
  border-radius: 5px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 12px;
}
.place-autocomplete-card {
  position: absolute;
  top: 15px;
  left: 15px;
  background-color: #fff;
  border-radius: 4px;
  height: 36px;
  width: 30%;
  line-height: 36px;
  border: 1px solid #dcdfe6;
  z-index: 99;
}
</style>
